import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'help-b3000-component',
  templateUrl: './help-b3000.component.html',
})
export class HelpB3000Component implements OnInit {
  loginDatas: UntypedFormGroup;
  loginDataRaw: any;
  translator = new TranslatePipe(this._LocalizationService);
  selectedCategory = 0;
  categoryList = [
    { id: 1, value: 'Mein Konto' },
    { id: 2, value: 'Technisches Problem' },
    { id: 3, value: 'Finanzen' },
    { id: 4, value: 'Wettschein-Fragen' },
    { id: 5, value: 'Cashback' },
    { id: 6, value: 'Sonstige' },
  ];

  problemList = [];

  constructor(
    private _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _route: ActivatedRoute,
    private _router: Router,
    public _UserHelper: UserHelper,
    public _LocalizationService: LocalizationService,
    public _DataHelper: DataHelper,
    public _MatDialog: MatDialog,
    private _FormBuilder: UntypedFormBuilder
  ) {
    this.loginDatas = _FormBuilder.group({
      userName: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(2)]),
      email: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.email]),
      category: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      problem: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      message: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
    });
  }

  ngOnInit() {
    this.loginDatas.valueChanges.subscribe(x => {
      // this.registerDatas.controls['mail'].status(VALID);
      this.loginDataRaw = x;
      if (x.category == 1) {
        this.problemList = [
          { id: 1, value: 'Benutzename vergessen' },
          { id: 2, value: 'Passwort vergessen' },
          { id: 3, value: 'E-Mail-Adresse ändern' },
          { id: 4, value: 'Konto sperren' },
          { id: 5, value: 'Konto entsperren' },
        ];
      } else if (x.category == 2) {
        this.problemList = [
          { id: 1, value: 'App' },
          { id: 2, value: 'Website' },
          { id: 3, value: 'Mobile Website' },
        ];
      } else if (x.category == 3) {
        this.problemList = [
          { id: 1, value: 'Fragen zur Einzahlung' },
          { id: 2, value: 'Fragen zur Auszahlung' },
        ];
      } else if (x.category == 4) {
        this.problemList = [
          { id: 1, value: 'Sportwetten' },
          { id: 2, value: 'Livewetten' },
          { id: 3, value: 'E-Mail-Adresse ändern' },
          { id: 4, value: 'Einsatzlimit' },
        ];
      } else if (x.category == 5) {
        this.problemList = [{ id: 1, value: 'Wie funktioniert Cashback ?' }];
      } else if (x.category == 6) {
        this.problemList = [{ id: 1, value: 'Was ist das Problem?' }];
      }
    });
  }

  SendMessage() {
    this._UiHelper.setLoadingDialog(true);
    if (this.loginDataRaw != undefined) {
      const userName = this.loginDataRaw.userName;
      const email = this.loginDataRaw.email;
      const category = this.categoryList.filter(x => x.id == this.loginDataRaw.category)[0].value;
      const problem = this.problemList.filter(x => x.id == this.loginDataRaw.problem)[0].value;
      const message = this.loginDataRaw.message;

      this._ApiService.helpMail(userName, email, category, problem, message).then(x => {
        this.loginDatas.reset();
        this.loginDatas.markAsPristine();
        this.loginDatas.markAsUntouched();
        this.loginDatas.updateValueAndValidity();
      });
    }
  }
}
